module.exports = __webpack_public_path__ + "static/img/RWA1866-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA1866-G_1.png
// module id = +h2U
// module chunks = 0